import React from 'react'

const Awards = () => {
  return (
    <div className="flex max-w-768 mx-auto md:px-64">
      <div className="w-1/3 px-4 md:px-12 lg:px-16">
        <img
          src={require('media/award-android.png')}
          alt="Android Excellence, Google Play 2017"
        />
      </div>
      <div className="w-1/3 px-4 md:px-12 lg:px-16">
        <img
          src={require('media/award-apple-2018.png')}
          alt="Editors’ Choice, App Store 2018"
        />
      </div>
      <div className="w-1/3 px-4 md:px-12 lg:px-16">
        <img
          src={require('media/award-google-play.png')}
          alt="Best of Google Play 2017 &amp; 2018"
        />
      </div>
    </div>
  )
}

export default Awards
